<template>
    <v-dialog v-model="dialogSwitch" persistent scrollable width="700">
        <v-card>
            <v-card-title id="heading" class="d-flex justify-space-between">
                <h4>Exclude Device for Payment (#{{ device.slno }})</h4>
                <v-btn density="compact" icon="mdi-close" variant="flat"
                       :disabled="processing"
                       @click="$emit('update:modelValue',false)"
                />
            </v-card-title>

            <v-container>
                <v-alert v-if="errors.length" class="mb-3 bg-error" density="compact" variant="tonal">
                    <p v-for="error in errors">{{ error }}</p>
                </v-alert>
                <v-row>
                    <v-col cols="12" class="text-center">
                        <v-btn
                            :color="device.bypass_payment? 'default':'warning'"
                            :loading="processing"
                            @click="toggleStatus">
                            {{ device.bypass_payment ? 'Disable' : 'Enable' }}
                        </v-btn>
                    </v-col>
                </v-row>
            </v-container>

            <v-card-actions class="px-4 d-flex justify-end">
                <v-btn size="small" type="button" @click="$emit('update:modelValue',false)">
                    Close
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script setup>
import {ref} from "vue";
import {send} from "@/composables/apiClient";
import {useSnackbarStore} from "@/stores/snackBarStore";

const snackbar = useSnackbarStore();
const props = defineProps({
    modelValue: Boolean,
    device: Object
});
const emits = defineEmits(['update:modelValue']);
const dialogSwitch = ref(props.modelValue);
const processing = ref(false);
const errors = ref([]);

const toggleStatus = () => {
    errors.value = [];
    const confirmation = confirm("Are you sure to " + (props.device.bypass_payment ? 'Disable' : 'Enable') + ` Payment Exclusion of # ${props.device.slno}`)
    if (!confirmation) {
        return false
    }
    processing.value = true;
    send('post', `devices/${props.device.id}/toggle-payment-exclusion`, {
        'status': props.device.bypass_payment ? 0 : 1
    }).then((response) => {
        if (response.data.success) {
            props.device.bypass_payment = response.data.data.status;
            snackbar.showSnackbar(response.data.message);
        }
    }).catch(function (errorResponse) {
        if (errorResponse.response.data.errors) {
            let validationErrors = errorResponse.response.data.errors;
            Object.keys(validationErrors).forEach((key) => {
                errors.value.push(validationErrors[key][0]);
            });
        } else if (errorResponse.response.data.message) {
            errors.value.push(errorResponse.response.data.message);
        }
        snackbar.showSnackbar('Something went wrong', 'error');
        document.getElementById('heading').scrollIntoView({behavior: 'smooth'});
    }).finally(() => processing.value = false)
}

</script>
